<div class="freeform-collection-container">
  <div class="page-main">
  <header class="page-toolbar">
    <nav class="section-nav" role="tablist" aria-label="Freeform Collection sections">
      <button type="button" class="section-tab" [class.active]="workspaceTab === 'extract'" (click)="setWorkspaceTab('extract')">Extract</button>
      <button type="button" class="section-tab" [class.active]="workspaceTab === 'cluster-review'" (click)="setWorkspaceTab('cluster-review')">Cluster review</button>
      <button type="button" class="section-tab" [class.active]="workspaceTab === 'related'" (click)="setWorkspaceTab('related')">Related</button>
    </nav>

    <div class="toolbar-controls">
      <div class="date-range-wrap">
        <date-range-picker
          pickerContext="freeform"
          [initialStartDate]="startDate"
          [initialEndDate]="endDate"
          (onDateSelect)="onDateRangeSelect($event)"
          [customFormat]="'DD MMM YYYY'">
        </date-range-picker>
        <button
          type="button"
          class="icon-btn date-range-hint"
          [matTooltip]="dateRangeSyncTooltip"
          matTooltipClass="ff-date-sync-tooltip"
          matTooltipPosition="below"
          matTooltipShowDelay="200"
          aria-label="Date range and one-day sync guidance">
          <mat-icon>info_outline</mat-icon>
        </button>
      </div>

      <timezone></timezone>

      <button class="primary-btn" type="button" (click)="runPrimaryAction()" [disabled]="isLoading">
        <mat-icon>{{ primaryActionIcon }}</mat-icon>
        {{ primaryActionLabel }}
      </button>

      <div class="download-wrap" *ngIf="workspaceTab === 'extract'">
        <button
          class="icon-btn"
          type="button"
          (click)="exportCsv()"
          [disabled]="isLoading || !canDownload"
          [matTooltip]="canDownload ? 'Download extract CSV' : 'Extract first to download'">
          <mat-icon>download</mat-icon>
        </button>

        <div class="download-panel" *ngIf="showDownloadOptions" (click)="$event.stopPropagation()">
          <div class="download-panel-header">
            <strong>What do you want to download?</strong>
            <button type="button" class="icon-btn tiny" (click)="closeDownloadOptions()">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <ng-container *ngIf="extractResult">
            <div class="download-section">
              <div class="download-label">Quick scope</div>
              <div class="pill-group compact">
                <button type="button" class="pill" [class.active]="downloadScope === 'current_view'" (click)="setDownloadScope('current_view')">Current view</button>
                <button type="button" class="pill" [class.active]="downloadScope === 'selection'" (click)="setDownloadScope('selection')">Custom selection</button>
              </div>
            </div>

            <div class="download-section">
              <div class="download-label">
                Fields
                <ng-container *ngIf="downloadScope === 'selection'">
                  <button type="button" class="link-btn" (click)="selectAllDownloadFields(true)">All</button>
                  <button type="button" class="link-btn" (click)="selectAllDownloadFields(false)">None</button>
                </ng-container>
              </div>
              <label class="check-row" *ngFor="let tab of fieldTabs" [class.locked]="downloadScope === 'current_view'">
                <input
                  type="checkbox"
                  [checked]="downloadFields[tab.key]"
                  [disabled]="downloadScope === 'current_view'"
                  (change)="toggleDownloadField(tab.key)" />
                <span>{{ tab.label }}</span>
              </label>
            </div>

            <div class="download-section" *ngIf="extractResult.mode === 'unique'">
              <div class="download-label">Include</div>
              <label class="check-row" [class.locked]="downloadScope === 'current_view'">
                <input
                  type="checkbox"
                  [(ngModel)]="downloadLayers.free_form"
                  [disabled]="downloadScope === 'current_view'"
                  (ngModelChange)="onDownloadLayerChange()" />
                <span>Free-form values</span>
              </label>
              <label class="check-row" *ngIf="hasClusteredDownloadFields" [class.locked]="downloadScope === 'current_view'">
                <input
                  type="checkbox"
                  [(ngModel)]="downloadLayers.clustered"
                  [disabled]="downloadScope === 'current_view'"
                  (ngModelChange)="onDownloadLayerChange()" />
                <span>Clustered values</span>
              </label>
              <label class="check-row" *ngIf="hasClusteredDownloadFields" [class.locked]="downloadScope === 'current_view'">
                <input
                  type="checkbox"
                  [(ngModel)]="downloadLayers.mapping"
                  [disabled]="downloadScope === 'current_view'"
                  (ngModelChange)="onDownloadLayerChange()" />
                <span>Cluster ↔ free-form mapping</span>
              </label>
            </div>

            <p class="download-preview">{{ downloadPreviewLabel }}</p>
            <p class="download-hint">{{ downloadHint }}</p>
            <p class="download-hint" *ngIf="extractDownloadBusy">Preparing full export…</p>
          </ng-container>

          <div class="download-actions">
            <button type="button" class="secondary-btn" (click)="closeDownloadOptions()">Cancel</button>
            <button type="button" class="primary-btn" (click)="confirmDownload()" [disabled]="!downloadOptionsValid || extractDownloadBusy">
              <mat-icon>download</mat-icon>
              {{ extractDownloadBusy ? 'Preparing…' : 'Download CSV' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <div class="workspace-body">
    <div class="workspace-main">
  <div class="error-banner" *ngIf="errorMessage && !isLoading">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <div class="loading-panel" *ngIf="isLoading">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Loading…</p>
  </div>

  <!-- EXTRACT -->
  <section class="content-panel" *ngIf="!isLoading && workspaceTab === 'extract'">
    <div class="panel-toolbar extract-toolbar">
      <div class="filter-group mode-filter">
        <span class="filter-label">Mode</span>
        <div class="pill-group">
          <button type="button" class="pill" [class.active]="extractMode === 'unique'" (click)="setExtractMode('unique')">Unique</button>
          <button type="button" class="pill" [class.active]="extractMode === 'all'" (click)="setExtractMode('all')">All rows</button>
        </div>
      </div>

      <div class="filter-group field-filter">
        <span class="filter-label">Field</span>
        <div class="pill-group field-pills">
          <button type="button" class="pill" [class.active]="extractFieldFilter === 'ALL'" (click)="setExtractFieldFilter('ALL')">All fields</button>
          <button
            type="button"
            class="pill"
            *ngFor="let tab of pairedFieldTabs"
            [class.active]="isExtractFieldPillActive(tab.key)"
            (click)="onExtractFieldPillClick(tab.key)">
            {{ tab.label }}
          </button>
          <span class="pill-divider" aria-hidden="true"></span>
          <button
            type="button"
            class="pill"
            *ngFor="let tab of taxonomyFieldTabs"
            [class.active]="isExtractFieldPillActive(tab.key)"
            (click)="onExtractFieldPillClick(tab.key)">
            {{ tab.label }}
          </button>
        </div>
      </div>

      <div class="filter-group mode-filter" *ngIf="extractResult?.mode === 'unique' && fieldHasClustered()">
        <span class="filter-label">View</span>
        <div class="pill-group">
          <button type="button" class="pill" [class.active]="activeView === 'free_form'" (click)="setActiveView('free_form')">Free-form</button>
          <button type="button" class="pill" [class.active]="activeView === 'clustered'" (click)="setActiveView('clustered')">Clustered</button>
          <button type="button" class="pill" [class.active]="activeView === 'mapping'" (click)="setActiveView('mapping')">Mapping</button>
        </div>
      </div>
    </div>

    <div class="status-strip" *ngIf="extractResult">
      <div class="meta">
        <span><span class="muted">Range</span> <strong>{{ extractResult.start_date }} → {{ extractResult.end_date }}</strong></span>
        <span><span class="muted">Conversations</span> <strong>{{ extractResult.total_conversations | number }}</strong></span>
        <span *ngIf="extractResult.mode === 'all'"><span class="muted">Rows</span> <strong>{{ (extractResult.total_rows || extractResult.row_count) | number }}</strong></span>
        <span *ngIf="extractResult.mode === 'unique'"><span class="muted">Unique values</span> <strong>{{ visibleExtractCount | number }}</strong></span>
        <span class="warn-pill" *ngIf="extractResult.truncated">Hard-capped</span>
      </div>
      <div class="search-wrap tight">
        <mat-icon>search</mat-icon>
        <input type="text" [(ngModel)]="searchTerm" placeholder="Search this page…" />
      </div>
    </div>

    <div class="table-shell" *ngIf="extractResult?.mode === 'unique' && activeView === 'free_form'">
      <table>
        <thead><tr><th class="col-index">#</th><th>Free-form value</th><th class="col-count">Count</th></tr></thead>
        <tbody>
          <tr *ngFor="let row of filteredFreeForm; let i = index"><td class="col-index">{{ (extractPage - 1) * extractPageSize + i + 1 }}</td><td>{{ row.value }}</td><td class="col-count">{{ row.count | number }}</td></tr>
          <tr *ngIf="!filteredFreeForm.length"><td colspan="3" class="empty">No free-form values found.</td></tr>
        </tbody>
      </table>
    </div>

    <div class="table-shell" *ngIf="extractResult?.mode === 'unique' && activeView === 'clustered'">
      <table>
        <thead><tr><th class="col-index">#</th><th>Clustered value</th><th class="col-count">Count</th></tr></thead>
        <tbody>
          <tr *ngFor="let row of filteredClustered; let i = index"><td class="col-index">{{ (extractPage - 1) * extractPageSize + i + 1 }}</td><td>{{ row.value }}</td><td class="col-count">{{ row.count | number }}</td></tr>
          <tr *ngIf="!filteredClustered.length"><td colspan="3" class="empty">No clustered values found.</td></tr>
        </tbody>
      </table>
    </div>

    <div class="table-shell" *ngIf="extractResult?.mode === 'unique' && activeView === 'mapping'">
      <table>
        <thead><tr><th class="col-index">#</th><th>Cluster</th><th>Free-form value</th><th class="col-count">Count</th></tr></thead>
        <tbody>
          <tr *ngFor="let row of filteredMapping; let i = index"><td class="col-index">{{ (extractPage - 1) * extractPageSize + i + 1 }}</td><td>{{ row.cluster_value }}</td><td>{{ row.free_form_value }}</td><td class="col-count">{{ row.count | number }}</td></tr>
          <tr *ngIf="!filteredMapping.length"><td colspan="4" class="empty">No mappings found.</td></tr>
        </tbody>
      </table>
    </div>

    <div class="table-shell all-rows" *ngIf="extractResult?.mode === 'all'">
      <table>
        <thead><tr><th *ngFor="let col of allRowsColumns">{{ col }}</th></tr></thead>
        <tbody>
          <tr *ngFor="let row of filteredAllRows"><td *ngFor="let col of allRowsColumns">{{ row[col] }}</td></tr>
          <tr *ngIf="!filteredAllRows.length"><td [attr.colspan]="allRowsColumns.length" class="empty">No rows found.</td></tr>
        </tbody>
      </table>
    </div>

    <div class="extract-pager" *ngIf="showExtractPager">
      <button type="button" class="pill" [disabled]="extractPage <= 1" (click)="setExtractPage(extractPage - 1)">Previous</button>
      <span class="muted">{{ extractPageLabel }} · {{ extractPageSize }} per page</span>
      <button type="button" class="pill" [disabled]="extractPage >= extractTotalPages" (click)="setExtractPage(extractPage + 1)">Next</button>
    </div>

    <div class="empty-state" *ngIf="!extractResult">
      <mat-icon>table_view</mat-icon>
      <h2>Extract Topics, TRPO &amp; context fields</h2>
      <p>
        Pick a field (or All fields), then Extract. Unique returns every distinct value with counts (paginated in the UI).
        Download from this tab exports the fields and layers you pick in <strong>What do you want to download?</strong> — the full list, not just the current page.
      </p>
    </div>
  </section>

  <!-- RELATED -->
  <section class="content-panel" *ngIf="!isLoading && workspaceTab === 'related'">
    <div class="panel-toolbar">
      <div class="nl-search">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          [(ngModel)]="relatedQuery"
          (keyup.enter)="runRelated()"
          placeholder="Describe a concept, e.g. delay compensation denied" />
        <button type="button" class="primary-btn compact" (click)="runRelated()" [disabled]="isLoading">Find</button>
      </div>
      <div class="search-wrap" *ngIf="relatedResult">
        <mat-icon>search</mat-icon>
        <input type="text" [(ngModel)]="searchTerm" placeholder="Search matches…" />
      </div>
    </div>

    <div class="stat-row" *ngIf="relatedResult">
      <div class="stat"><span class="muted">Tokens</span><strong>{{ relatedResult.tokens?.join(', ') || '—' }}</strong></div>
      <div class="stat"><span class="muted">Matches</span><strong>{{ relatedResult.matches?.length || 0 }}</strong></div>
    </div>

    <div class="table-shell" *ngIf="relatedResult">
      <table>
        <thead><tr><th class="col-index">#</th><th>Field</th><th>Layer</th><th>Value</th><th class="col-count">Count</th><th class="col-count">Score</th><th>Matched</th></tr></thead>
        <tbody>
          <tr *ngFor="let row of relatedRows; let i = index">
            <td class="col-index">{{ i + 1 }}</td>
            <td>{{ row.field_label }}</td>
            <td>{{ row.layer }}</td>
            <td>{{ row.value }}</td>
            <td class="col-count">{{ row.count | number }}</td>
            <td class="col-count">{{ row.score | number:'1.1-2' }}</td>
            <td>{{ row.matched_tokens?.join(', ') }}</td>
          </tr>
          <tr *ngIf="!relatedRows.length"><td colspan="7" class="empty">No related values in this date range.</td></tr>
        </tbody>
      </table>
    </div>

    <div class="empty-state" *ngIf="!relatedResult">
      <mat-icon>manage_search</mat-icon>
      <h2>Find related values</h2>
      <p>Enter a natural-language scenario to match Topics and TRPO free-form / clustered values.</p>
    </div>
  </section>

  <!-- CLUSTER MAP -->
  <section class="content-panel scrollable" *ngIf="!isLoading && workspaceTab === 'cluster-map'">
    <div class="panel-toolbar">
      <div class="pill-group">
        <button type="button" class="pill" [class.active]="clusterMapField === 'ALL'" (click)="clusterMapField = 'ALL'; runClusterGraph()">All fields</button>
        <button type="button" class="pill" *ngFor="let tab of pairedFieldTabs" [class.active]="clusterMapField === tab.key" (click)="clusterMapField = tab.key; runClusterGraph()">{{ tab.label }}</button>
      </div>
      <div class="search-wrap" *ngIf="clusterGraphResult">
        <mat-icon>search</mat-icon>
        <input type="text" [(ngModel)]="searchTerm" placeholder="Search candidates…" />
      </div>
    </div>

    <ng-container *ngIf="clusterGraphResult">
      <div class="stat-row">
        <div class="stat"><span class="muted">Clusters</span><strong>{{ clusterGraphResult.summary?.cluster_nodes | number }}</strong></div>
        <div class="stat"><span class="muted">Free-form</span><strong>{{ clusterGraphResult.summary?.free_form_nodes | number }}</strong></div>
        <div class="stat"><span class="muted">Edges</span><strong>{{ clusterGraphResult.summary?.edges | number }}</strong></div>
        <div class="stat"><span class="muted">Candidates</span><strong>{{ clusterGraphResult.summary?.candidates | number }}</strong></div>
      </div>

      <div class="insight-grid" *ngIf="clusterGroups?.length">
        <div class="insight-card" *ngFor="let g of clusterGroups | slice:0:6">
          <h3>{{ g.suggested_cluster_name }}</h3>
          <p class="card-meta">{{ g.field_label }} · {{ g.member_count }} values · {{ g.total_count | number }}</p>
          <ul>
            <li *ngFor="let m of g.members | slice:0:5">
              <span class="tag">{{ m.current_cluster }}</span>
              <span class="val">{{ m.free_form_value }}</span>
              <span class="chg">{{ m.count }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="table-shell embedded">
        <table>
          <thead>
            <tr>
              <th class="col-index">#</th><th>Field</th><th>Suggested cluster</th><th>Free-form</th>
              <th>Current cluster</th><th class="col-count">Count</th><th class="col-count">Overlap</th><th>Why</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of clusterCandidates; let i = index">
              <td class="col-index">{{ i + 1 }}</td>
              <td>{{ row.field_label }}</td>
              <td><strong>{{ row.suggested_cluster_name }}</strong></td>
              <td>{{ row.free_form_value }}</td>
              <td>{{ row.current_cluster }}</td>
              <td class="col-count">{{ row.count | number }}</td>
              <td class="col-count">{{ row.lexical_overlap | number:'1.0-2' }}</td>
              <td>{{ row.reasons?.join(', ') }}</td>
            </tr>
            <tr *ngIf="!clusterCandidates.length"><td colspan="8" class="empty">No strong cluster candidates.</td></tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <div class="empty-state" *ngIf="!clusterGraphResult">
      <mat-icon>hub</mat-icon>
      <h2>Map clusters to free-form values</h2>
      <p>Build the graph to inspect structure and new cluster candidates.</p>
    </div>
  </section>

  <!-- CLUSTER REVIEW (HITL) -->
  <section class="content-panel hitl-section" *ngIf="!isLoading && workspaceTab === 'cluster-review'">
    <div class="workspace-filters review-filters">
      <div class="filter-group">
        <span class="filter-label">Bucket</span>
        <div class="pill-group compact-pills">
          <button type="button" class="pill" [class.active]="reviewBucket === 'other'" (click)="setReviewBucket('other')">Other / NA</button>
          <button type="button" class="pill" [class.active]="reviewBucket === 'human_review'" (click)="setReviewBucket('human_review')">70–90%</button>
          <button type="button" class="pill" [class.active]="reviewBucket === 'auto_assign'" (click)="setReviewBucket('auto_assign')">≥90%</button>
          <button type="button" class="pill" [class.active]="reviewBucket === 'create_new_cluster'" (click)="setReviewBucket('create_new_cluster')">&lt;70% high</button>
          <button type="button" class="pill" [class.active]="reviewBucket === 'mark_other'" (click)="setReviewBucket('mark_other')">&lt;70% low</button>
          <button type="button" class="pill" [class.active]="reviewBucket === 'all'" (click)="setReviewBucket('all')">All</button>
        </div>
      </div>
      <div class="filter-group">
        <span class="filter-label">Field</span>
        <div class="pill-group compact-pills">
          <button type="button" class="pill" [class.active]="reviewFieldFilter === 'ALL'" (click)="setReviewFieldFilter('ALL')">All</button>
          <button type="button" class="pill" *ngFor="let tab of clusterReviewFieldTabs" [class.active]="reviewFieldFilter === tab.key" (click)="setReviewFieldFilter(tab.key)">{{ tab.label }}</button>
        </div>
      </div>
      <div class="filter-group">
        <span class="filter-label">Range</span>
        <div class="pill-group compact-pills">
          <button type="button" class="pill" (click)="applyReviewRangePreset(21)" matTooltip="Last 21 days — good default for cluster review">3 weeks</button>
          <button type="button" class="pill" (click)="applyReviewRangePreset(90)" matTooltip="Last 90 days — chunked scans + min-count filter">3 months</button>
        </div>
      </div>
      <div class="filter-group options">
        <label class="check-row inline" matTooltip="On by default. Scores load from cache when available; only new values are embedded.">
          <input type="checkbox" [(ngModel)]="reviewIncludeScores" (change)="persistWorkspaceState(); loadClusterReview({ preserveSelection: true })" />
          <span>Closeness %</span>
        </label>
        <button
          type="button"
          class="secondary-btn compact refresh-queue-btn"
          (click)="refreshClusterReview()"
          [disabled]="isLoading"
          matTooltip="Reload values after assign/create — keeps tab, field, and selection">
          <mat-icon>refresh</mat-icon>
          Refresh
        </button>
        <div class="search-wrap tight" *ngIf="reviewItems.length">
          <mat-icon>search</mat-icon>
          <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="persistWorkspaceState()" placeholder="Search free-form…" />
        </div>
      </div>
    </div>

    <div class="status-strip" *ngIf="filteredReviewItems.length || reviewActionMessage || reviewLastCreatedCluster || reviewScoreCoverage.length">
      <span class="status-meta" *ngIf="filteredReviewItems.length">
        <strong>{{ filteredReviewItems.length | number }}</strong> values
        <span *ngIf="reviewWindowDays"> · {{ reviewWindowDays }}d</span>
        <span *ngIf="reviewMinCount && reviewMinCount > 1"> · min ≥ {{ reviewMinCount }}</span>
        <span> · {{ reviewFieldFilter === 'ALL' ? 'All fields' : reviewFieldFilter }}</span>
      </span>
      <span class="status-ok" *ngIf="reviewActionMessage">{{ reviewActionMessage }}</span>
      <span class="status-created" *ngIf="reviewLastCreatedCluster">New cluster: <strong>{{ reviewLastCreatedCluster }}</strong></span>
    </div>

    <div class="hitl-layout" *ngIf="filteredReviewItems.length; else reviewEmpty">
      <!-- 1. Values -->
      <aside class="hitl-pane queue-pane">
        <div class="pane-head">
          <h3>1. Values</h3>
          <span class="pane-count">{{ filteredReviewItems.length }}</span>
        </div>
        <div class="table-shell side-table review-queue">
          <table class="queue-map-table">
            <thead>
              <tr>
                <th class="col-index">#</th>
                <th>Free-form</th>
                <th>Cluster</th>
                <th class="col-count">n</th>
                <th class="col-count">%</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of filteredReviewItems; let i = index"
                [class.active-row]="activeReviewItem?.free_form_value === row.free_form_value && activeReviewItem?.field === row.field"
                (click)="openReviewItem(row)">
                <td class="col-index">{{ i + 1 }}</td>
                <td class="ff-cell">
                  <span class="ff-field">{{ row.field_label }}</span>
                  <span class="ff-value">{{ row.free_form_value }}</span>
                  <span class="ff-suggest">{{ row.recommendation?.label || 'Review' }}</span>
                </td>
                <td class="map-cluster-cell">
                  <span class="map-arrow" aria-hidden="true">→</span>
                  <span
                    class="map-cluster-name"
                    [class.catchall]="reviewItemMappedClusterIsCatchall(row)"
                    [matTooltip]="row.closest_clusters?.length ? ('Closest: ' + (row.closest_clusters[0].cluster_name || '') + ' @ ' + (row.similarity_pct != null ? (row.similarity_pct | number:'1.0-1') + '%' : '—')) : 'No closest cluster scored yet'">
                    {{ reviewItemMappedCluster(row) }}
                  </span>
                </td>
                <td class="col-count">{{ row.count | number }}</td>
                <td class="col-count">
                  <span class="score-pill" [class.mid]="row.similarity_pct != null && row.similarity_pct >= 70 && row.similarity_pct < 90"
                        [class.high]="row.similarity_pct != null && row.similarity_pct >= 90"
                        [class.low]="row.similarity_pct != null && row.similarity_pct < 70">
                    {{ row.similarity_pct != null ? (row.similarity_pct | number:'1.0-0') + '%' : '—' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </aside>

      <!-- 2. Read conversations -->
      <section class="hitl-pane read-pane" *ngIf="activeReviewItem as item; else pickReviewItem">
        <div class="pane-head">
          <div>
            <h3>2. Read conversations</h3>
            <p class="pane-sub">
              {{ item.field_label }} ·
              <ng-container *ngIf="reviewConversations.length">
                {{ reviewConversations.length }}<ng-container *ngIf="reviewConversationsTruncated"> of {{ reviewConversationsTotal }}</ng-container>
              </ng-container>
              <ng-container *ngIf="!reviewConversations.length">loading…</ng-container>
            </p>
          </div>
          <span class="rw-card-actions" *ngIf="reviewConversations.length">
            <button type="button" class="link-btn" (click)="toggleSelectAllReviewConversations(true)">All</button>
            <button type="button" class="link-btn" (click)="toggleSelectAllReviewConversations(false)">None</button>
          </span>
        </div>

        <div class="active-item-chip">
          <strong>{{ item.free_form_value }}</strong>
          <span>
            {{ item.count | number }} total ·
            closeness
            <ng-container *ngIf="item.similarity_pct != null">{{ item.similarity_pct | number:'1.0-1' }}%</ng-container>
            <ng-container *ngIf="item.similarity_pct == null">not scored</ng-container>
            · cluster {{ item.assigned_cluster_name || 'unassigned' }}
          </span>
        </div>

        <p class="rw-note warn" *ngIf="reviewConversationsTruncated">
          Showing first {{ reviewConversations.length }} of {{ reviewConversationsTotal }}. Narrow the date range for the rest.
        </p>
        <p class="rw-note" *ngIf="!reviewConversations.length">Loading conversations for this free-form…</p>

        <div class="convo-list-v2 fill" *ngIf="reviewConversations.length">
          <label
            class="convo-card"
            *ngFor="let c of reviewConversations"
            [class.selected]="selectedConversationKeys[conversationKey(c)]">
            <input type="checkbox" [(ngModel)]="selectedConversationKeys[conversationKey(c)]" />
            <div class="convo-card-body">
              <div class="convo-card-top">
                <strong class="convo-id">{{ c.ConversationId }}</strong>
                <span class="muted">{{ c.InitiationTimestamp }}</span>
              </div>
              <div class="convo-tags">
                <span class="tag">{{ c.PrimaryTopic || '—' }}</span>
                <span class="tag">{{ c.Intent || '—' }}</span>
                <span class="tag">{{ c.Sentiment || c.CustomerSentimentAtEnd || '—' }}</span>
                <span class="tag muted-tag">{{ c.current_cluster || item.assigned_cluster_name || '—' }}</span>
              </div>
              <p class="convo-summary" *ngIf="c.Summary">{{ c.Summary }}</p>
              <p class="convo-summary empty-sum" *ngIf="!c.Summary">No summary on this conversation.</p>
            </div>
          </label>
        </div>
        <p class="rw-selected-count" *ngIf="reviewConversations.length">
          <strong>{{ selectedReviewConversations.length }}</strong> of {{ reviewConversations.length }} selected
        </p>
      </section>

      <!-- 3. Act -->
      <section class="hitl-pane act-pane" *ngIf="activeReviewItem as item">
        <div class="pane-head">
          <div>
            <h3>3. Apply cluster</h3>
            <p class="pane-sub">Cluster label only</p>
          </div>
          <button type="button" class="secondary-btn compact" (click)="recompareActiveReview()" matTooltip="Re-score against catalog">
            <mat-icon>compare_arrows</mat-icon>
            Re-score
          </button>
        </div>

        <div class="act-body">
          <!-- Free-form ↔ cluster mapping with closeness % -->
          <div class="mapping-board">
            <div class="mapping-board-head">
              <span class="mapping-label">Free-form → cluster mapping</span>
              <span class="mapping-field-tag">{{ item.field_label }}</span>
            </div>

            <table class="mapping-table primary">
              <thead>
                <tr>
                  <th>Free-form value</th>
                  <th class="col-close">Closeness</th>
                  <th>Cluster value</th>
                </tr>
              </thead>
              <tbody>
                <tr class="mapping-active" [class.empty-target]="!reviewMappingTarget">
                  <td>
                    <strong class="map-ff">{{ item.free_form_value }}</strong>
                    <span class="map-sub">Current cluster: {{ item.assigned_cluster_name || 'unassigned' }}</span>
                  </td>
                  <td class="col-close">
                    <ng-container *ngIf="reviewActionMode === 'assign'">
                      <span
                        *ngIf="reviewMappingClosenessPct != null"
                        class="score-pill"
                        [class.high]="reviewMappingClosenessBand === 'high'"
                        [class.mid]="reviewMappingClosenessBand === 'mid'"
                        [class.low]="reviewMappingClosenessBand === 'low'">
                        {{ reviewMappingClosenessPct | number:'1.0-1' }}%
                      </span>
                      <span *ngIf="reviewMappingClosenessPct == null" class="map-na" matTooltip="Pick a closest match to see closeness, or Re-score">—</span>
                    </ng-container>
                    <span *ngIf="reviewActionMode === 'create'" class="map-na" matTooltip="New cluster — no closeness until after live scoring">new</span>
                    <span *ngIf="reviewActionMode === 'other'" class="map-na">—</span>
                  </td>
                  <td>
                    <strong class="map-cluster" [class.create]="reviewActionMode === 'create'">
                      {{ reviewMappingTarget || '— pick a cluster below —' }}
                    </strong>
                    <span class="map-sub" *ngIf="reviewMappingTarget && reviewActionMode === 'assign'">
                      Will map {{ selectedReviewConversations.length }} selected conversation(s)
                    </span>
                    <span class="map-sub" *ngIf="reviewMappingTarget && reviewActionMode === 'create'">
                      Will create &amp; map {{ selectedReviewConversations.length }} selected
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="mapping-candidates" *ngIf="reviewActionMode === 'assign' && item.closest_clusters?.length">
              <div class="download-label">Closest cluster mappings — click a row to select</div>
              <table class="mapping-table candidates">
                <thead>
                  <tr>
                    <th>Free-form</th>
                    <th class="col-close">Closeness</th>
                    <th>Cluster</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let c of item.closest_clusters"
                    class="mapping-candidate-row"
                    [class.picked]="reviewSelectedClusterName === c.cluster_name"
                    (click)="selectReviewCluster(c.cluster_name, { cluster_id: c.cluster_id, mechanism: c.mechanism })">
                    <td>{{ item.free_form_value }}</td>
                    <td class="col-close">
                      <span
                        class="score-pill"
                        [class.high]="c.similarity_pct != null && c.similarity_pct >= 90"
                        [class.mid]="c.similarity_pct != null && c.similarity_pct >= 70 && c.similarity_pct < 90"
                        [class.low]="c.similarity_pct != null && c.similarity_pct < 70">
                        {{ c.similarity_pct != null ? (c.similarity_pct | number:'1.0-1') + '%' : '—' }}
                      </span>
                    </td>
                    <td><strong>{{ c.cluster_name }}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="rw-note" *ngIf="reviewActionMode === 'assign' && !item.closest_clusters?.length">
              No closeness scores yet — click <strong>Re-score</strong> to compare this free-form against the {{ item.field_label }} catalog.
            </p>
          </div>

          <div class="rw-mode-tabs">
            <button type="button" class="rw-mode" [class.active]="reviewActionMode === 'assign'" (click)="reviewActionMode = 'assign'">Assign</button>
            <button type="button" class="rw-mode" [class.active]="reviewActionMode === 'create'" (click)="reviewActionMode = 'create'">Create</button>
            <button type="button" class="rw-mode" [class.active]="reviewActionMode === 'other'" (click)="reviewActionMode = 'other'">Other</button>
          </div>

          <div *ngIf="reviewActionMode === 'assign'" class="rw-mode-body">
            <label class="edit-field">
              Or pick any catalog cluster ({{ item.field_label }})
              <select
                [ngModel]="reviewSelectedClusterName"
                (ngModelChange)="selectReviewCluster($event)">
                <option value="">— select cluster —</option>
                <option *ngFor="let c of reviewClusterOptions" [ngValue]="c.cluster_name">
                  {{ c.cluster_name }}
                </option>
              </select>
            </label>
          </div>

          <div *ngIf="reviewActionMode === 'create'" class="rw-mode-body">
            <label class="edit-field">
              New cluster name
              <input
                type="text"
                [(ngModel)]="reviewNewClusterName"
                placeholder="e.g. Fare Discrepancy" />
            </label>
            <p class="rw-note">
              Maps <strong>{{ item.free_form_value }}</strong> → <strong>{{ reviewNewClusterName.trim() || '…' }}</strong>
              on selected conversations (closeness is not scored for a brand-new cluster yet).
            </p>
          </div>

          <div *ngIf="reviewActionMode === 'other'" class="rw-mode-body">
            <p class="rw-note">
              Maps <strong>{{ item.free_form_value }}</strong> → <strong>{{ reviewMappingTarget }}</strong>
              for the date range. Reassign later from Other / NA.
            </p>
          </div>

          <label class="check-row inline rw-upcoming" *ngIf="reviewActionMode !== 'other'">
            <input type="checkbox" [(ngModel)]="reviewApplyToUpcoming" />
            <span>Append mapping to catalog (upcoming live)</span>
          </label>
        </div>

        <footer class="rw-actions">
          <ng-container *ngIf="reviewActionMode === 'assign'">
            <button
              type="button"
              class="primary-btn"
              (click)="applySelectedConversationEdits()"
              [disabled]="!reviewSelectedClusterName || !selectedReviewConversations.length"
              [matTooltip]="reviewMappingTarget ? (item.free_form_value + ' → ' + reviewMappingTarget) : ''">
              Map → {{ reviewMappingTarget || 'cluster' }} ({{ selectedReviewConversations.length || 0 }})
            </button>
            <button
              type="button"
              class="secondary-btn"
              (click)="applyReassign()"
              [disabled]="!reviewSelectedClusterName"
              matTooltip="Updates every matching free-form in the date range">
              Bulk map range
            </button>
          </ng-container>

          <ng-container *ngIf="reviewActionMode === 'create'">
            <button
              type="button"
              class="primary-btn"
              (click)="applyCreateCluster()"
              [disabled]="!reviewNewClusterName.trim() || !selectedReviewConversations.length"
              [matTooltip]="item.free_form_value + ' → ' + (reviewNewClusterName.trim() || '…')">
              Create &amp; map ({{ selectedReviewConversations.length || 0 }})
            </button>
            <button
              type="button"
              class="secondary-btn"
              (click)="applyCreateClusterBulk()"
              [disabled]="!reviewNewClusterName.trim()"
              matTooltip="Creates the cluster and backfills every matching free-form in the date range">
              Bulk create range
            </button>
          </ng-container>

          <ng-container *ngIf="reviewActionMode === 'other'">
            <button type="button" class="secondary-btn danger-outline" (click)="applyMarkOther()">
              Keep / mark Other
            </button>
          </ng-container>
        </footer>
      </section>

      <ng-template #pickReviewItem>
        <div class="hitl-pane empty-pick span-2">
          <mat-icon>touch_app</mat-icon>
          <h3>Select a free-form</h3>
          <p>
            Rows already show <strong>Free-form → Cluster</strong> and closeness %.
            Click a row to read conversations and confirm Assign / Create.
          </p>
        </div>
      </ng-template>
    </div>

    <ng-template #reviewEmpty>
      <div class="empty-state">
        <mat-icon>rule</mat-icon>
        <h2>Human-in-loop cluster review</h2>
        <p>Choose a bucket and field, then Load review. Pick a free-form, read conversations, and apply a cluster label.</p>
      </div>
    </ng-template>
  </section>

    </div><!-- /.workspace-main -->
  </div><!-- /.workspace-body -->
  </div><!-- /.page-main -->

  <!-- Glossary-style right rail: Help + Coverage + Seed E2E -->
  <aside class="ff-right-sidebar" aria-label="Help and tools">
    <div class="ff-rail">
      <button
        type="button"
        class="ff-rail-btn"
        [class.active]="helpOpen"
        (click)="toggleHelp()"
        matTooltip="Help"
        matTooltipPosition="left"
        aria-label="Help">
        <mat-icon>{{ helpOpen ? 'help' : 'help_outline' }}</mat-icon>
      </button>
      <button
        type="button"
        class="ff-rail-btn coverage"
        [class.active]="coveragePanelOpen"
        (click)="toggleCoveragePanel()"
        matTooltip="Closeness score calendar"
        matTooltipPosition="left"
        aria-label="Closeness score calendar">
        <mat-icon>calendar_month</mat-icon>
      </button>
      <button
        *ngIf="showDevTestDataTools"
        type="button"
        class="ff-rail-btn seed"
        [class.active]="showTestDataPanel"
        (click)="toggleTestDataPanel()"
        matTooltip="Seed E2E (dev)"
        matTooltipPosition="left"
        aria-label="Seed E2E">
        <mat-icon>science</mat-icon>
      </button>
    </div>

    <div class="ff-side-panel" *ngIf="rightDrawer !== 'none'" [class.seed]="rightDrawer === 'seed'" [class.coverage]="rightDrawer === 'coverage'">
      <!-- COVERAGE CALENDAR -->
      <ng-container *ngIf="rightDrawer === 'coverage'">
        <div class="right-drawer-header coverage">
          <div>
            <h2>Score calendar</h2>
            <p>Closeness % coverage · {{ reviewFieldFilter === 'ALL' ? 'All fields' : reviewFieldFilter }}</p>
          </div>
          <button type="button" class="icon-btn tiny" (click)="closeRightDrawer()" aria-label="Close coverage panel">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="right-drawer-body coverage-body">
          <p class="coverage-intro">
            ✓ scored days are in the DB (cache). Select a day to Load (cache) or Reprocess (re-embed).
          </p>
          <p class="coverage-sub-line" *ngIf="reviewCoverageSummary">{{ reviewCoverageSummary }}</p>

          <div class="coverage-actions stacked">
            <button
              type="button"
              class="primary-btn compact full-width"
              (click)="loadSelectedCoverageDay()"
              [disabled]="isLoading || !reviewCalendarSelectedDay"
              matTooltip="Set date range to the selected day and Load (uses DB cache when available)">
              <mat-icon>play_arrow</mat-icon>
              Load day
            </button>
            <button
              type="button"
              class="secondary-btn compact full-width"
              (click)="reprocessSelectedCoverageDay()"
              [disabled]="isLoading || !reviewCalendarSelectedDay"
              matTooltip="Re-embed closeness % for the selected day (ignores score cache)">
              <mat-icon>refresh</mat-icon>
              Reprocess day
            </button>
            <button
              type="button"
              class="secondary-btn compact full-width"
              (click)="reprocessCurrentCoverageRange()"
              [disabled]="isLoading || !startDate || !endDate"
              matTooltip="Re-embed closeness % for the current page date range. Prefer one calendar day at a time at production volume (~15k conversations/day).">
              <mat-icon>replay</mat-icon>
              Reprocess range
            </button>
          </div>

          <div class="coverage-calendar in-drawer">
            <div class="cal-nav">
              <button type="button" class="icon-btn" (click)="shiftReviewCalendarMonth(-1)" aria-label="Previous month">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <span class="cal-month">{{ reviewCalendarMonthLabel }}</span>
              <button type="button" class="icon-btn" (click)="shiftReviewCalendarMonth(1)" aria-label="Next month">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
            <div class="cal-weekdays">
              <span>Su</span><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span><span>Sa</span>
            </div>
            <div class="cal-grid">
              <button
                type="button"
                class="cal-day"
                *ngFor="let cell of reviewCalendarCells"
                [class.empty]="!cell.inMonth"
                [class.complete]="cell.status === 'complete'"
                [class.partial]="cell.status === 'partial'"
                [class.selected]="cell.selected"
                [class.in-range]="cell.inRange"
                [class.today]="cell.isToday"
                [disabled]="!cell.date"
                (click)="selectCoverageCalendarDay(cell.date)"
                [matTooltip]="cell.date ? (cell.date + (cell.status === 'complete' ? ' · scored ✓' : cell.status === 'partial' ? ' · partial' : ' · not scored')) : ''">
                <span class="cal-num" *ngIf="cell.dayNum != null">{{ cell.dayNum }}</span>
                <span class="cal-tick" *ngIf="cell.status === 'complete'" aria-hidden="true">✓</span>
                <span class="cal-tick partial-tick" *ngIf="cell.status === 'partial'" aria-hidden="true">!</span>
              </button>
            </div>
            <div class="cal-legend">
              <span><i class="leg complete"></i> Scored</span>
              <span><i class="leg partial"></i> Partial</span>
              <span><i class="leg selected"></i> Selected</span>
              <span><i class="leg range"></i> Current range</span>
            </div>
            <p class="coverage-empty-hint" *ngIf="!reviewCoverageSummary">
              No scored days yet — Load Cluster review with Closeness % to stamp ticks.
            </p>
            <p class="coverage-selected-hint" *ngIf="reviewCalendarSelectedDay">
              Selected: <strong>{{ reviewCalendarSelectedDay }}</strong>
              <span *ngIf="reviewCalendarDays[reviewCalendarSelectedDay] as cov">
                · {{ cov.status === 'complete' ? 'scored' : cov.status }}
                <span *ngIf="cov.fields?.length"> · {{ cov.fields.join(', ') }}</span>
              </span>
            </p>
          </div>
        </div>
      </ng-container>

      <!-- SEED E2E -->
      <ng-container *ngIf="rightDrawer === 'seed'">
        <div class="right-drawer-header seed">
          <div>
            <h2>Seed E2E data</h2>
            <p>Dev only · {{ dataSourceLabel }}</p>
          </div>
          <button type="button" class="icon-btn tiny" (click)="closeRightDrawer()" aria-label="Close seed panel">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="right-drawer-body seed-body">
          <p class="dev-test-data-hint">
            Runs sample airline transcripts through Bedrock (when available), writes rows into
            <code>insights_with_contact_metadata_table</code> + review values, then refreshes Freeform from live APIs.
            Same rows appear on Insights Dashboard for the selected date range.
          </p>

          <div class="dev-test-data-controls stacked">
            <label class="check-row inline">
              <input type="checkbox" [(ngModel)]="testDataUseBedrock" />
              <span>Use Bedrock extraction</span>
            </label>
            <label class="inline-field">
              <span>Copies / scenario</span>
              <input type="number" min="1" max="10" [(ngModel)]="testDataCountPerScenario" />
            </label>
            <label class="inline-field">
              <span>Days back</span>
              <input type="number" min="0" max="60" [(ngModel)]="testDataDaysBack" />
            </label>
            <button
              type="button"
              class="primary-btn compact full-width"
              (click)="generateBedrockTestData()"
              [disabled]="isLoading || testDataGenerating">
              <mat-icon>auto_awesome</mat-icon>
              {{ testDataGenerating ? 'Seeding…' : (testDataUseBedrock ? 'Generate into RDS' : 'Generate scripted into RDS') }}
            </button>
          </div>

          <div class="dev-test-data-scenarios drawer" *ngIf="testDataScenarios.length">
            <div class="download-label">
              Transcript scenarios
              <button type="button" class="link-btn" (click)="selectAllTestScenarios(true)">All</button>
              <button type="button" class="link-btn" (click)="selectAllTestScenarios(false)">None</button>
            </div>
            <label class="check-row" *ngFor="let s of testDataScenarios">
              <input type="checkbox" [checked]="!!selectedTestScenarioIds[s.id]" (change)="toggleTestScenario(s.id)" />
              <span>{{ s.label }} <span class="muted">({{ s.id }} · {{ s.turns || 0 }} turns)</span></span>
            </label>
          </div>

          <p class="dev-test-data-result" *ngIf="testDataMessage">{{ testDataMessage }}</p>
          <ul class="dev-test-data-howto" *ngIf="testDataHowTo.length">
            <li *ngFor="let tip of testDataHowTo">{{ tip }}</li>
          </ul>
          <div class="dev-test-data-created" *ngIf="testDataCreated.length">
            <div class="download-label">Seeded conversations</div>
            <div class="created-row" *ngFor="let row of testDataCreated">
              <code>{{ row.conversation_id }}</code>
              <span class="muted">{{ row.label }} · {{ row.extraction_mode }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- HELP -->
      <ng-container *ngIf="rightDrawer === 'help'">
        <div class="right-drawer-header">
          <div>
            <h2>Help</h2>
            <p>Guide for the current tab</p>
          </div>
          <button type="button" class="icon-btn tiny" (click)="closeRightDrawer()" aria-label="Close help">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <nav class="help-nav" aria-label="Help sections">
          <button type="button" [class.active]="helpFocus === 'overview'" (click)="setHelpFocus('overview')">Start here</button>
          <button type="button" [class.active]="helpFocus === 'extract'" (click)="setHelpFocus('extract')">Extract</button>
          <button type="button" [class.active]="helpFocus === 'cluster-review'" (click)="setHelpFocus('cluster-review')">Cluster review</button>
          <button type="button" [class.active]="helpFocus === 'related'" (click)="setHelpFocus('related')">Related</button>
        </nav>

        <div class="help-body">
          <ng-container *ngIf="helpFocus === 'overview'">
            <h3>What is this workspace?</h3>
            <p>
              Explore the <strong>words and labels</strong> Care Insights attaches to customer conversations —
              free-text wording, embedding clusters used for reporting, and closed taxonomy fields such as Intent.
            </p>
            <ol class="help-steps">
              <li>Pick a <strong>date range</strong> and timezone in the top toolbar. The default is yesterday and the day before. At production volume (~15k conversations/day), sync or Load <strong>one calendar day at a time</strong>.</li>
              <li>Choose a tab: Extract, Cluster review, or Related.</li>
              <li>Press the purple action button (Extract / Load review / Find related, etc.).</li>
              <li>Use <strong>Download</strong> on Extract when you want a CSV. The file matches the fields and layers you pick in the download panel.</li>
            </ol>
            <div class="help-callout">
              <strong>Two kinds of fields</strong>
              <p><strong>Free-form / clustered</strong> — Topics, Root Cause, Pain Point, Trigger, Outcome. Exact AI wording plus the cluster bucket used for charts. Fix mappings in Cluster review.</p>
              <p><strong>Closed taxonomy</strong> — Primary Topic, Intent, Sentiment, Journey Moment, Caller Type, Resolution. Fixed dropdown values (not embedding clusters). Browse them in Extract.</p>
            </div>
            <div class="help-callout tip">
              <strong>Need to fix labels?</strong>
              <p>
                Use <button type="button" class="help-inline-link" (click)="setHelpFocus('cluster-review'); setWorkspaceTab('cluster-review')">Cluster review</button>
                for free-form → cluster mappings. Closeness % =
                embedding cosine similarity × 100 vs the catalog (open that Help section for the full definition).
                Browse Primary Topic, <strong>Intent</strong>, Sentiment, and other taxonomy values in Extract.
                <strong>Intent is not a cluster.</strong>
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="helpFocus === 'extract'">
            <h3>Extract</h3>
            <p>Pull values for the selected dates so you can browse or download them.</p>
            <h4>Mode</h4>
            <ul>
              <li><strong>Unique</strong> — each distinct value once, with a count.</li>
              <li><strong>All rows</strong> — one row per conversation, with Summary plus taxonomy and Topics/TRPO columns.</li>
            </ul>
            <p class="help-note">Summary appears only on All rows.</p>
            <h4>Field pills</h4>
            <p>One row: clusterable fields, then a divider, then taxonomy (Primary Topic, Intent, …). Intent is not a cluster.</p>
            <h4>All fields vs one field</h4>
            <p>
              <strong>All fields</strong> extracts everything. In Unique mode, click a field pill to switch the view without re-fetching.
              Click the same active field again to pin Extract to that field only.
            </p>
            <h4>Download</h4>
            <p>
              The download button is only on Extract. <strong>Current view</strong> exports the field and layer on screen.
              <strong>Custom selection</strong> exports the fields and layers you check. The preview line is exactly what the CSV contains.
            </p>
          </ng-container>

          <ng-container *ngIf="helpFocus === 'cluster-review'">
            <h3>Cluster review</h3>
            <p>
              Correct free-form → cluster mappings for Topics, Root Cause, Pain Point, Trigger, and Outcome.
              Intent and other closed taxonomy fields can be browsed in Extract; this tab only edits cluster labels.
            </p>
            <p class="help-note">
              <strong>Values</strong> = every distinct free-form in the date range for the selected
              field + bucket (Other/NA, 70–90%, …), with conversation count.
              ~15k/day is only a volume estimate — it does not limit which values appear.
              Sync / Load <strong>one calendar day at a time</strong> so closeness scoring stays within prod limits
              (timeouts, DB pool, Bedrock embeds). Per-day cache and the score calendar are the upside.
              One Load scores closeness % for every value (cache first, then embed all misses).
            </p>
            <p class="help-note">
              <strong>Closeness score calendar</strong> (right sidebar · calendar icon) shows days already scored (✓) or partial (!).
              Opens automatically on Cluster review. Select a day → <em>Load day</em> (uses DB cache) or <em>Reprocess day</em> (re-embeds).
              <em>Reprocess range</em> forces a fresh score pass for the current page dates.
            </p>

            <h4>How closeness % is calculated</h4>
            <div class="help-callout tip">
              <strong>Definition</strong>
              <p>
                Closeness is <strong>embedding cosine similarity × 100</strong> between the free-form text
                and the closest exemplar in the field’s reference catalog
                (<code>embedding_cluster_reference_catalog</code>).
              </p>
            </div>
            <ol class="help-steps">
              <li>Take the free-form string (e.g. “storm delay cancelled flight”).</li>
              <li>Embed it with the same Bedrock Cohere model the live classifier uses.</li>
              <li>Run nearest-neighbor (KNN) search against catalog exemplars for that field (Topics / Root Cause / …).</li>
              <li>Keep the best match per cluster name, then take the top closest clusters.</li>
              <li>
                Similarity is cosine on vectors:
                <code>similarity = 1 − distance</code> (pgvector), reported as
                <strong>closeness % = similarity × 100</strong> (e.g. 0.87 → 87%).
              </li>
            </ol>
            <p class="help-note">
              Scores can come from the live pipeline emit queue / score cache, or from
              <strong>Re-score / Compare</strong> in this UI. Creating a <em>new</em> cluster has no closeness yet —
              it becomes matchable after its free-form exemplar is appended to the catalog.
            </p>
            <p class="help-note">
              No description field is required to create a cluster. The free-form text itself is the exemplar
              that future wording is compared against; the cluster name is the human/reporting label.
            </p>

            <h4>What the % means (HITL bands)</h4>
            <table class="help-table">
              <thead><tr><th>Closeness</th><th>What to do</th></tr></thead>
              <tbody>
                <tr><td>≥ 90%</td><td>Safe to assign to the closest cluster</td></tr>
                <tr><td>70–90%</td><td>Human chooses existing or new cluster</td></tr>
                <tr><td>&lt; 70% and count ≥ 100</td><td>Likely needs a new cluster</td></tr>
                <tr><td>&lt; 70% and count &lt; 100</td><td>Keep as Other / NA</td></tr>
              </tbody>
            </table>
            <p class="help-note">
              Live auto-accept in the Insights pipeline still uses ~55–60%. These 70/90 bands are for
              human review only and do not change the live classifier thresholds.
            </p>
            <p class="help-note">Prefer Save to selected conversations. Taxonomy values can be browsed in Extract.</p>
          </ng-container>

          <ng-container *ngIf="helpFocus === 'related'">
            <h3>Related</h3>
            <p>Keyword match against free-form and clustered Topics/TRPO values. No LLM. Intent is not clustered here.</p>
          </ng-container>


        </div>
      </ng-container>
    </div>
  </aside>
</div>
